var style = {"modalHeader":"ModalHeader-module_modalHeader__4rJbI","modalTitle":"ModalHeader-module_modalTitle__qeCws","modalHeaderScrollable":"ModalHeader-module_modalHeaderScrollable__aj7T4"};

export { style as default };
//# sourceMappingURL=ModalHeader.module.scss.js.map
